<template>
    <div v-if="show" class="mask">
        <div class="form-modal doc-edit-plus-modal flex flex-col ">
            <div class="flex flex-space-between flex-center-cz title border-box ">
                <div class="margin-left-l font-s">{{title}}</div>
                <img src="@/assets/images/guanbi.png" class="logo-18 margin-right-m pointer" @click="close"/>
            </div>       
            <div class="flex content border-box flex-col">
                <div class="flex padding-m flex-center-cz flex-space-between border-box" style="height: 36px;">
                    <div class="border-box">文件名称：<span class="font-bold">{{formData.name}}</span></div>
                    <div class="flex flex-end border-box">
                        <div class="ui-no-button flex flex-center-cz flex-center-sp border-box margin-right-m" @click="importClick">导入</div>    
                        <div class="ui-yes-button flex flex-center-cz flex-center-sp border-box" @click="addItem">添加</div>    
                    </div>
                </div>
                <vue-custom-scrollbar class="book border-box rtfDiv"  v-html="formData.content"></vue-custom-scrollbar>
            </div>
        </div>
        <InsertTestModal  ref="insertTestModal" @add="insertTestConfirm"  ></InsertTestModal>
        <InsertQuestionModal  ref="insertQuestionModal" @add="insertQuestionConfirm"  ></InsertQuestionModal>
        <InsertTimeModal  ref="insertTimeModal" @add="insertTimeConfirm"  ></InsertTimeModal>
        <SelectQuestionModal  ref="selectQuestionModal" @add="selectQuestionConfirm" ></SelectQuestionModal>

        <popup-menu ref="opMenu" :menuData="opMenuData"  @menuClick="opMenuClick"></popup-menu>
        <input hidden accept="*.xlsx" type="file" ref="testFileAdd1" @change="getTestFile" />
        <input hidden accept="*.xlsx" type="file" ref="questionFileAdd1" @change="getQuestionFile" />
    </div>
</template>

<script>
    import RichText from '@/components/richText/RichText' 
    import Select from '@/components/select/Select' 
    import InsertTestModal from '@/views/plugs/InsertTestModal'
    import { getUUID } from '../../utils/sysUtils'
    import { getJsDate, getNowDate } from '../../utils/dateUtils'
    import InsertQuestionModal from '../plugs/InsertQuestionModal.vue'
    import MixinHtml from '@/mixin/mixinHtml.js';
    import PopupMenu from '@/components/popupMenu/PopupMenu' 
    import * as utils from "@/utils/httpUtils.js"
    import config from '@/config/index.js'
    import {  importTest,importQuestion,copyQuestion } from '@/api/api.js';
    import InsertTimeModal from '../plugs/InsertTimeModal.vue'
    import SelectQuestionModal from '../plugs/SelectQuestionModal.vue'


    export default {
        name:'DocEditPlusModal',
        created() {
        },
        mixins:[MixinHtml],
        components:{RichText,Select,InsertTestModal,InsertQuestionModal,PopupMenu,InsertTimeModal,SelectQuestionModal},
        props:{
            title:{} 
        },
        data() {
            return {
                show: null,
                formData:{},
                opMenuData: [
                    {id:'exportTest',name:'下载导入模板'},
                    {id:'exportQuestion',name:'下载导入模板'},
                    {id:'importTest',name:'从文件导入'},
                    {id:'importQuestion',name:'从文件导入'},
                    {id:'importQuestionA',name:'从题库导入'},
 
                ],
            }
        },
        methods:{
            selectQuestionConfirm(data) {
                this.$showLoading();
                let postBody = {id: this.formData.id, dataIds: data}
                copyQuestion(postBody).then((res) => {
                    console.log("res==", res);
                    this.$closeLoading();
                    if (res.data.success == true) {
                        this.formData.content = res.data.message;
                        this.$refs.selectQuestionModal.close();    
                    }
                }) 
            },
            getTestFile() {
                let files = this.$refs.testFileAdd1.files[0];
                console.log("files", files)
                this.$showLoading();
                importTest(files,this.formData.id).then((res) => {
                    this.$closeLoading();
                    if (res.data.success == true) {
                        this.formData.content = res.data.message;
                    }
                })  
            },
            getQuestionFile() {
                let files = this.$refs.questionFileAdd1.files[0];
                console.log("files", files)
                this.$showLoading();
                importQuestion(files,this.formData.id).then((res) => {
                    this.$closeLoading();
                    if (res.data.success == true) {
                        this.formData.content = res.data.message;
                    }
                })  

            },
            open(data) {
                this.formData = data;
                this.editFileData = data;
                this.editFileData.insertContent = 1;
                this.show = true; 
            },
            queryClick() {

            },
            importClick(event) {    
                if (this.formData.docType == "test") {
                    this.opMenuData = this.opMenuData.filter(d=>d.id == "exportTest" || d.id == "importTest")     
                }
                if (this.formData.docType == "question") {
                    this.opMenuData = this.opMenuData.filter(d=>d.id == "exportQuestion" || d.id == "importQuestion" || d.id == "importQuestionA")     
                }
      
                this.$refs.opMenu.show(event);
            },
            opMenuClick(id) {
                if (id == 'exportTest') {
                    utils.downFile("/static/excel/test.xlsx", "测试问题导入模板.xlsx");      
                }
                if (id == 'importTest') {
                    this.$refs.testFileAdd1.click();     
                }
                if (id == 'exportQuestion') {
                    utils.downFile("/static/excel/question.xlsx", "试题导入模板.xlsx");      
                }
                if (id == 'importQuestion') {
                    this.$refs.questionFileAdd1.click();     
                }
                if (id == 'importQuestionA') {
                    this.$refs.selectQuestionModal.showForm();     
                }

            },
            addItem() {
                let newId = getUUID()
                let nowDate = getNowDate();
                let fileId = this.formData.id;
                if (this.formData.docType == 'test') {
                    this.$refs.insertTestModal.newForm({id: newId, date: nowDate, fileId: fileId, status:"未完成", finish:"完成"});
                } else if (this.formData.docType == 'question') {
                    this.$refs.insertQuestionModal.newForm({id: newId, date: nowDate, fileId: fileId});
                } else if (this.formData.docType == 'time') {
                    this.$refs.insertTimeModal.newForm({id: newId, date: nowDate, fileId: fileId});
                }
            },
            close() {
                this.$emit("close")
                this.show = false;
                
            },
        }
   }
</script>

<style scoped>

    .rtfDiv {
        padding-left: 50px ;
        padding-right: 50px;
        padding-top: 30px ;
        padding-bottom: 30px ;
        margin-left: 10px;
        margin-right: 10px;
        background-color: #fff;
        flex-grow: 1;
    }

    .rtfDiv >>> img {
        max-width: 100% ;
    }

    .form-modal {
        top:20px;
    }
    .form-modal .content{
        height: calc(100% - 50px);
        flex-flow: 1;
    }
    .doc-edit-plus-modal {
        width: 1100px;
        height: 820px;
        background-color: #ddd;
    }

    
</style>


// WEBPACK FOOTER //
// src/views/modal/DocEditPlusModal.vue